<template>
    <b-container id="Projects" class="Projects wrapper">
        <b-row>
            <b-col cols="12">
                <h2 class="tac">{{$t('projects.title')}}</h2>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" v-for="(projects, i) in myJson.projects" :key="i">
                <Project
                    :trigger="$t('projects.projects['+i+'].trigger')" 
                    :anim="$t('projects.projects['+i+'].anim')" 
                    :animlogo="$t('projects.projects['+i+'].animlogo')" 
                    :logo="$t('projects.projects['+i+'].logo')"
                    :alt="$t('projects.projects['+i+'].title')" 
                    :img="$t('projects.projects['+i+'].img')"
                    :bg="$t('projects.projects['+i+'].bg')"
                    :title="$t('projects.projects['+i+'].title')" 
                    :msg="$t('projects.projects['+i+'].msg')" />
            </b-col>
        </b-row>
    </b-container>
</template> 

<script> 
import Project from "@/components/home/Project.vue"
import json from '@/locales/en.json'

export default {
    name: 'Projects',
    data: function() {
        return {
            myJson: json.projects
        }
    },
    components: {
        Project,
    }
} 
</script>


<style scoped lang="scss">
@import '@/assets/style/projects.scss';
</style>